import { getFilmById } from '../films/get-film-by-id';
import { getShowtimeById } from './get-showtime-by-id';
export const getFilmForShowtime = (showtimeId) => {
    const showtime = getShowtimeById(showtimeId);
    if (!showtime)
        return undefined;
    return getFilmById(showtime.filmId);
};
//# sourceMappingURL=get-film-for-showtime.js.map